import { getPromotionalPrice } from '@/presenters/components/catalog/PriceTag/utils';

import { pushDataObject } from '../../tracker/data-layer';
import { getCurrentVariants, getDiscountType, getDiscount } from '../../utils';

import { type PushAddToCartServicePdpProps } from './types';
import { formatItemForDataLayer } from './utils';

const getItemTotalPrice = (price: number, quantity: number) => price * quantity;

export const pushAddToCartServicePDP = (
  props: PushAddToCartServicePdpProps
) => {
  const { product, currentSeller, variants, category, quantity, serviceData } =
    props;

  const isBox = product.pack && product.pack.packaging !== 1;
  const isTwoPrices = currentSeller.pricing.discount.type === 'twoPrices';
  const promotionalPrice = getPromotionalPrice(currentSeller.pricing.price);
  const discount = getDiscount(
    currentSeller.pricing.price.to,
    promotionalPrice
  );

  const productItemData = {
    id: product._id,
    name: product.name,
    type: 'product',
    price: currentSeller.pricing.price.to,
    discount: isTwoPrices ? undefined : discount,
    discountType: getDiscountType(currentSeller.pricing.discount.type),
    brand: product.brand,
    categoryTree: category.tree,
    variants: getCurrentVariants(product._id, variants || []),
    seller: currentSeller.shop.name || 'Leroy Merlin',
    quantity,
    box: isBox
      ? {
          unit: product.pack.packaging || undefined,
          price: product.pack.price || undefined,
          quantity: quantity,
        }
      : undefined,
  };

  const serviceItemData = {
    id: serviceData.id,
    bind_id: product._id,
    name: serviceData.name,
    type: 'service',
    price: serviceData.price.to,
    brand: currentSeller.shop.name,
    categoryTree: 'serviço',
    seller: currentSeller.shop.name,
    quantity,
  };

  const formattedProductItem = formatItemForDataLayer(productItemData);
  const formattedServiceItem = formatItemForDataLayer(serviceItemData);

  const totalValue =
    getItemTotalPrice(productItemData.price, quantity) +
    getItemTotalPrice(serviceItemData.price, quantity);

  pushDataObject({
    _clear: true,
    event: 'add_to_cart',
    page_type: 'product',
    items: [formattedProductItem, formattedServiceItem],
    add_to_cart: {
      value: totalValue,
    },
  });
};
